/** Status copy from remaining seats — prefers API `availableSeats` when provided. */
export const getSeatsStatusLabel = (seatsAvailable, seatsTotal, seatsTaken = 0) => {
  const remaining =
    Number.isFinite(Number(seatsAvailable)) && seatsAvailable >= 0
      ? Number(seatsAvailable)
      : Math.max(0, seatsTotal - seatsTaken);

  if (remaining <= 0) return 'Full';
  if (remaining === 1) return 'Almost full';
  if (remaining <= 2) return 'Filling up';
  // return `${remaining} seats left`;
  return '';
};
